import type { ServiceCard, ServiceDetail } from '../types';

export const serviceCards: ServiceCard[] = [
  {
    icon: 'pi-cog',
    name: 'Technik allgemein',
    description:
      'PC, Drucker, digitale Einrichtung – ich bin Ihr Ansprechpartner für pragmatische Hilfe vor Ort.',
    color: '#38bdf8',
  },
  {
    icon: 'pi-shopping-cart',
    name: 'Hardware-Kaufberatung',
    description:
      'Unabhängige Beratung ohne Provisionen – was wirklich zu Ihnen passt, nicht was sich am besten verkauft.',
    color: '#38bdf8',
  },
  {
    icon: 'pi-home',
    name: 'SmartHome Beratung',
    description:
      'Von einzelnen Sensoren bis zur kompletten Planung – plattformunabhängig und individuell.',
    color: '#38bdf8',
  },
  {
    icon: 'pi-wifi',
    name: 'Netzwerk & WLAN',
    description:
      'WLAN-Analyse, Mesh-Planung, Router-Einrichtung – ich bringe Ordnung in Ihr Heimnetz.',
    color: '#38bdf8',
  },
  {
    icon: 'pi-print',
    name: '3D Druck Service',
    description:
      'Ersatzteile, Gehäuse, Prototypen – lassen Sie uns gemeinsam Ihre Ideen umsetzen.',
    color: '#38bdf8',
  },
];

export const serviceDetails: ServiceDetail[] = [
  {
    icon: 'pi-cog',
    name: 'Technik allgemein',
    color: '#38bdf8',
    description:
      'Ob PC, Drucker oder digitale Einrichtung – ich bin Ihr Ansprechpartner für pragmatische Hilfe. Ich komme zu Ihnen nach Hause und löse das Problem direkt vor Ort.',
    price: 'ab 60 €',
  },
  {
    icon: 'pi-shopping-cart',
    name: 'Hardware-Kaufberatung',
    color: '#38bdf8',
    description:
      'Ich berate Sie unabhängig – ohne Provisionen oder Produktempfehlungen im Eigeninteresse. Sie bekommen eine ehrliche Einschätzung, was wirklich zu Ihnen passt.',
    price: 'ab 30 €',
  },
  {
    icon: 'pi-home',
    name: 'SmartHome Beratung',
    color: '#38bdf8',
    description:
      'Von der Nachrüstung einzelner Sensoren bis zur kompletten Planung im Neubau. Ich arbeite mit verschiedenen Systemen (HomeAssistant, KNX, Zigbee u.a.) und berate plattformunabhängig.',
    price: 'ab 75 €',
  },
  {
    icon: 'pi-wifi',
    name: 'Netzwerk & WLAN',
    color: '#38bdf8',
    description:
      'Ich optimiere Ihr Heimnetz – vom Repeater über Access Points bis zur strukturierten Verkabelung. WLAN-Analyse, Mesh-Planung, Router-Einrichtung.',
    price: 'nach Aufwand',
  },
  {
    icon: 'pi-print',
    name: '3D Druck Service',
    color: '#38bdf8',
    description:
      '3D Druck eröffnet viele neue Möglichkeiten: Ersatzteile, Gehäuse, Dekor, Prototypen. Lassen Sie uns gemeinsam Ihre Ideen umsetzen.',
    price: 'nach Aufwand',
  },
];
